export const NO_RISK_PROFILE_MSG = 'Das Risikoprofil wurde noch nicht ermittelt.';